
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
// reportThunk.js

export const fetchReportsByFilter = createAsyncThunk(
  "report/fetchReportsByFilter",
  async (filters, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `https://v3.dhundhoo.com/reports/${filters.card}`,
        filters
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Unknown error");
    }
  }
);

